import React, { Fragment, useContext } from "react";
// import { useDispatch , useSelector } from 'react-redux';
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";

// import { navtoggle } from "../../../store/actions/AuthActions";
import Logo from './../../../icons/logo.svg';

const NavHader = () => {
  // const [toggle, setToggle] = useState(false);
  const { navigationHader, background } = useContext(
    ThemeContext
  );

  // const dispatch = useDispatch();
  // const sideMenu = useSelector(state => state.sideMenu);
  // const handleToogle = () => {
  //   dispatch(navtoggle());
  // };
  return (
    <div className="nav-header">
      <Link to="/" className="brand-logo">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
              <img className="logo-abbr" width="36" height="36" src={Logo} alt="D-Wallet" />
              <div className="brand-title text-black">D-Wallet</div>
          </Fragment>
        ) : (
          <Fragment>
              <img className="logo-abbr" width="36" height="36" src={Logo} alt="D-Wallet" />
              <div className="brand-title text-black">D-Wallet</div>
          </Fragment>
        )}
      </Link>

      {/*<div*/}
      {/*  className="nav-control"*/}
      {/*  onClick={() => {          */}
      {/*    handleToogle()*/}
      {/*    openMenuToggle();*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>*/}
      {/*    <span className="line"></span>*/}
      {/*    <span className="line"></span>*/}
      {/*    <span className="line"></span>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default NavHader;
